import clsx from 'clsx'
import React from 'react'
import { DrawerContentBody, DrawerContentFooter, DrawerContentHeader } from '@components/foundation/drawer/Drawer'
import { Skeleton } from '@components/foundation/skeleton/Skeleton'
import styles from '../styles/RedirectLoadingSkeleton.module.scss'

type InsuranceFormSkeletonProps = {
  showProgress?: boolean
}

export const RedirectLoadingSkeleton: React.FC<InsuranceFormSkeletonProps> = ({ showProgress }) => {
  return (
    <>
      <DrawerContentHeader>
        <HeaderSkeleton showProgress={showProgress} />
      </DrawerContentHeader>

      <DrawerContentBody>
        <ContentSkeleton />
      </DrawerContentBody>

      <DrawerContentFooter>
        <FooterSkeleton />
      </DrawerContentFooter>
    </>
  )
}

const HeaderSkeleton: React.FC<InsuranceFormSkeletonProps> = ({ showProgress }) => {
  return (
    <>
      {showProgress && (
        <>
          <Skeleton variant="line" className={styles.progressMobile} />
          <Skeleton variant="circle" className={styles.backButtonMobile} />
          <div className={styles.progress}>
            <Skeleton variant="circle" />
            <Skeleton variant="line" />
          </div>
        </>
      )}

      <div className={styles.header}>
        <div className={styles.title}>
          <Skeleton variant="text" width="75%" />
          <Skeleton variant="text" width="55%" />
        </div>
      </div>
    </>
  )
}

const ContentSkeleton: React.FC = () => {
  return (
    <div className={styles.content}>
      <div className={styles.input}>
        <Skeleton variant="input" width="100%" />
        <Skeleton variant="text" width="35%" />
      </div>
      <div className={styles.input}>
        <Skeleton variant="input" width="100%" />
        <Skeleton variant="text" width="35%" />
      </div>
      <div className={styles.input}>
        <Skeleton variant="input" width="100%" />
        <Skeleton variant="text" width="35%" />
      </div>
      <div className={styles.input}>
        <Skeleton variant="input" width="100%" />
      </div>
      <div className={styles.input}>
        <Skeleton variant="input" width="100%" />
      </div>
      <div className={clsx(styles.input, styles.multilineInput)}>
        <div className={styles.checkbox}>
          <Skeleton variant="circle" />
          <Skeleton variant="text" />
        </div>
        <Skeleton variant="text" />
        <Skeleton variant="text" />
      </div>
    </div>
  )
}

const FooterSkeleton: React.FC = () => {
  return (
    <div className={styles.footer}>
      <Skeleton variant="text" width="200px" />
      <Skeleton variant="button" width="130px" />
    </div>
  )
}
